interface ICorProfessor {
  id_cor: number;
  id_professor: number;
}

function mapear_cores_professores(cores_professores: ICorProfessor[]) {
  const map = new Map<number, number>();

  cores_professores.forEach((c) => {
    map.set(c.id_professor, c.id_cor);
  });

  return map;
}

export { mapear_cores_professores };
